/** Document format options — keep in sync with backend/services/document_format.py */

export const DOCUMENT_FORMATS = [
  { value: 'blog', label: 'Blog article', defaultWordCount: 1200 },
  { value: 'case_study', label: 'Case study', defaultWordCount: 1500 },
  { value: 'white_paper', label: 'White paper', defaultWordCount: 4000 },
  { value: 'integration_guide', label: 'Integration guide', defaultWordCount: 2500 },
];

export function formatLabel(value) {
  const fmt = DOCUMENT_FORMATS.find((f) => f.value === value);
  return fmt ? fmt.label : 'Blog article';
}

export function defaultWordCountForFormat(value) {
  const fmt = DOCUMENT_FORMATS.find((f) => f.value === value);
  return fmt ? fmt.defaultWordCount : 1200;
}

export function normalizeDocumentFormat(value) {
  if (!value || value === 'blog') return 'blog';
  return DOCUMENT_FORMATS.some((f) => f.value === value) ? value : 'blog';
}
